export const T_Emails = {
  EMAIL_HELLO: {
    EN_US: "Good morning",
    FR_FR: "Bonjour",
  },
  EMAIL_RESET_PASSWORD_TITLE: {
    EN_US: "Reset your password",
    FR_FR: "Réinitialisez votre mot de passe",
  },
  EMAIL_RESET_PASSWORD_TEXT: {
    EN_US: "You asked to reset your password. Click the link below to create a new one !",
    FR_FR:
      "Vous avez demandé à réinitialiser votre mot de passe. Cliquez sur le lien ci-dessous pour en créer un nouveau !",
  },
  EMAIL_RESET_MY_PASSWORD_ACTION: {
    EN_US: "Reset my password",
    FR_FR: "Réinitialiser mon mot de passe",
  },
  EMAIL_IGNORE_REQUEST: {
    EN_US: "If you did not request this, you can safely ignore this email.",
    FR_FR:
      "Si vous n’êtes pas à l’origine de cette demande, vous pouvez ignorer cet e-mail en toute sécurité.",
  },
  EMAIL_BEST_REGARDS: {
    EN_US: "Best regards",
    FR_FR: "Cordialement",
  },
  EMAIL_TEAM: {
    EN_US: "The Team Kliq pro",
    FR_FR: "L’équipe Kliq pro",
  },
  EMAIL_INVITE_TITLE: {
    EN_US: "You’ve been invited to Kliq Pro",
    FR_FR: "Vous avez été invité à rejoindre Kliq Pro",
  },
  EMAIL_INVITE_TEXT: {
    EN_US:
      "Your account has been created. Click the link below to set your password and access the platform.",
    FR_FR:
      "Votre compte a été créé. Cliquez sur le lien ci-dessous pour définir votre mot de passe et accéder à la plateforme.",
  },
  EMAIL_INVITE_ACTION: {
    EN_US: "Create my account",
    FR_FR: "Créer mon compte",
  },
};
